import './forms/scripts'
import './navbar/scripts'

// Sliders
import './img-slider/scripts'
import './partner/scripts'

// Accordion after sliders
// This ensures the sliders already listen to any accordion events
import './accordion/scripts'



// WEBPACK FOOTER //
// ./src/components/index.js